import { isValidJSON } from '../../utils/pageConfig'

export function parseJsonArray (value) {
  if (Array.isArray(value)) return value
  if (typeof value === 'string' && value.trim()) {
    if (!isValidJSON(value)) return []
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  }
  return []
}

export function isImageModuleData (jsonData) {
  if (!jsonData || typeof jsonData !== 'object') return false
  return (
    jsonData.sceneAreaImages !== undefined ||
    jsonData.sceneAreaRegions !== undefined ||
    jsonData.greenTechnologyImages !== undefined ||
    jsonData.greenTechnologyPoints !== undefined
  )
}

export function parseImageModuleJsonData (parsed = {}) {
  return {
    sceneAreaImages: parseJsonArray(parsed.sceneAreaImages),
    sceneAreaRegions: parseJsonArray(parsed.sceneAreaRegions),
    greenTechnologyImages: parseJsonArray(parsed.greenTechnologyImages),
    greenTechnologyPoints: parseJsonArray(parsed.greenTechnologyPoints)
  }
}

export function isImageModule (item, index) {
  if (index === 3) return true
  if (item?.jsonData && typeof item.jsonData === 'object' && isImageModuleData(item.jsonData)) {
    return true
  }
  if (item?.jsonData && isValidJSON(item.jsonData)) {
    return isImageModuleData(JSON.parse(item.jsonData))
  }
  return false
}
